import { render, staticRenderFns } from "./noPondsView.vue?vue&type=template&id=61755608&"
import script from "./noPondsView.vue?vue&type=script&lang=js&"
export * from "./noPondsView.vue?vue&type=script&lang=js&"
import style0 from "./noPondsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports